// Types of subtexts: list-decimal
export const KAZ_RULES = [
  // 1
  {
    title: '1. Жалпы ережелер',
    list: [
      {
        id: 1,
        text: 'Осы «Білім-инновация» лицейлеріне оқуға қабылдау ережелері (бұдан әрі – Ережелер) 2007 жылғы 27 шілдедегі Қазақстан Республикасының «Білім туралы» Заңына, «Жоғары және жоғары оқу орнынан кейінгі білім беру ұйымдарын қоспағанда, тиісті типтердегі және түрлердегі білім беру ұйымдары қызметінің үлгілік қағидаларын бекіту туралы» ҚР Оқу-ағарту министрінің 31.08.2022 ж. №385 бұйрығына, «Олимпиадалық резервтің республикалық, облыстық, республикалық маңызы бар қалалардың, астананың мамандандырылған мектеп-интернат-колледждерін және спорттағы дарынды балаларға арналған облыстық, республикалық маңызы бар қалалардың, астананың мектеп-интернаттарын қоспағанда, бастауыш, негізгі орта және жалпы орта білімнің жалпы білім беретін оқу бағдарламаларын іске асыратын білім беру ұйымдарына оқуға қабылдаудың үлгілік қағидаларын бекіту туралы» ҚР БҒМ 12.10.2018 ж. №564 бұйрығына сәйкес әзірленді.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 2,
        text: '«Білім-инновация» лицейлеріне (бұдан әрі – БИЛ) оқуға қабылдау конкурс негізінде (бұдан әрі – конкурс) жүзеге асады.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 3,
        text: 'Конкурсқа Қазақстан Республикасының жалпы білім беретін мектептерінің 6-сынып оқушылары (бұдан әрі – үміткерлер) қатыса алады.',
        subtext: {
          type: null,
          content: [],
        },
      },
    ],
  },
  // 2
  {
    title: '2. Құжаттарды қабылдау тәртібі',
    list: [
      {
        id: 4,
        text: 'Конкурсты ұйымдастыру және өткізу үшін «БІЛІМ-ИННОВАЦИЯ» Халықаралық қоғамдық қоры (бұдан әрі – Қор) президентінің бұйрығымен құрамы 5 (бес) адамнан тұратын қор басшылығы, әдіскерлері мен мамандарынан конкурстық комиссия құрылады.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 5,
        text: 'Конкурсқа қатысу үшін құжаттарды қабылдау, тестілеуді өткізу үшін облыстарда және Астана, Алматы, Шымкент қалаларында БИЛ директорының/міндетін атқарушының бұйрығымен құрамы 5 (бес) адамнан тұратын БИЛ педагогтері мен қызметкерлерінен қабылдау комиссиясы құрылады.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 6,
        text: 'БИЛ директорының/міндетін атқарушының бұйрығымен құжаттарды қабылдау үшін жауапты тұлға тағайындалады.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 7,
        text: 'БИЛ-ге түсуге үміткердің ата-анасынан немесе өзге де заңды өкілінен конкурсқа қатысу үшін құжаттарды қабылдау 2026 жылдың 2 қараша мен 2027 жылдың 2 сәуір аралығында жүргізіледі.',
        subtext: {
          type: null,
          content: [
            '7.1. Конкурсқа қатысу үшін үміткердің ата-анасы немесе өзге де заңды өкілі белгіленген мерзімде www.bilemtihan.kz сілтемесі арқылы тіркеуден өтеді.',
          ],
        },
      },
      {
        id: 8,
        text: 'Конкурсқа қатысу үшін төмендегі құжаттардың электрондық нұсқалары (жүктеу үшін файл форматы: .jpg, .jpeg, .pdf) қажет:',
        subtext: {
          type: null,
          content: [
            '1) үміткердің ЖСН көрсетілген туу туралы куәлігінің көшірмесі;',
            '2) үміткердің ақшыл фондағы фотосуреті;',
            '3) халықтың әлеуметтік осал топтарына жататындығын растайтын құжаттары (болған жағдайда).',
            '8.1. Құжаттардың түпнұсқаларын тапсыру талап етілмейді (8-тармақ, 3-тармақшадан басқасы, бұл тармақшада көрсетілген құжаттың түпнұсқасы www.bilemtihan.kz сайтында тіркелгеннен кейін 5 жұмыс күні ішінде БИЛ-дің қабылдау комиссиясына тапсырылады).',
            '8.2. Құжаттарды қабылдау аяқталғаннан кейін қабылдау комиссиясы ұсынылған құжаттардың іріктеу өлшемшарттарына сәйкестігін тексереді және растайтын құжаттардың түпнұсқаларын қосымша сұратады (қажет болса).',
            '8.3. Құжаттарды тексеру аяқталған соң үміткерлердің ата-анасының немесе өзге де заңды өкілдерінің тіркеуде көрсетілген телефон нөміріне немесе электрондық поштасына рұқсатнама жіберіледі.',
            '8.4. Үміткер тестілеуге келген кезде жеке басын сәйкестендіру үшін өзімен бірге туу туралы куәлігін (түпнұсқа) және рұқсатнаманы қағаз түрінде ұсынады.',
            '8.5. Атырау қаласындағы ер балаларға арналған БИЛ-ге – «Атырау облысы Білім беру басқармасының №1 «Білім-инновация» лицей-интернаты» КММ-не (бұдан әрі – «Атырау ерлер БИЛ») және «Атырау облысы Білім беру басқармасының №2 «Білім-инновация» лицей-интернаты» КММ-не (бұдан әрі – «Сарайшық ерлер БИЛ») құжаттарды қабылдау кезінде үміткер негізгі мектеп пен екінші мектепті таңдау арқылы мектептердің басымдығын көрсетуі тиіс.',
            '8.6. Қызылорда қаласындағы БИЛ-ге – «Қызылорда облысының білім басқармасының «Сейілбек Шаухаманов атындағы №9 дарынды балаларға арналған облыстық «Білім-инновация» лицей-интернаты» КММ-не (бұдан әрі – «Қызылорда ерлер БИЛ»), Қызылорда облысының білім басқармасының «№10 дарынды балаларға арналған облыстық «Білім-инновация» лицей-интернаты» КММ-не (бұдан әрі – «Қызылорда қыздар БИЛ») және Қызылорда облысының білім басқармасының физика-математика бағытындағы «Білім-инновация» лицей-интернатына (бұдан әрі – «Қызылорда БИЛ физмат») құжаттарды қабылдау кезінде үміткер жынысына сәйкес тиісті екі мектепке:',
            '• Ер балалар – «Қызылорда ерлер БИЛ» мен «Қызылорда БИЛ физмат»,',
            '• Қыз балалар – «Қызылорда қыздар БИЛ» мен «Қызылорда БИЛ физмат» мектептеріне үміткер болады және негізгі мектеп пен екінші мектепті таңдау арқылы мектептердің басымдығын көрсетуі тиіс.',
          ],
        },
      },
      {
        id: 9,
        text: 'Үміткер тұрғылықты жерінен конкурсқа қатысуға тіркелу үшін, облыс бойынша бірнеше тестілеу орталығы болған жағдайда, өзіне ыңғайлы емтихан тапсыру орнын таңдайды, рұқсат қағаз берілген кезде таңдалған тест орталығының мекенжайы көрсетіледі.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 10,
        text: 'Конкурсқа қатысу туралы өтінішті белгіленген мерзімнен кеш беру, кез келген БИЛ-ге тіркеуден өткен үміткердің қайта тіркелуі немесе құжаттар топтамасын толық ұсынбау құжаттарды қабылдаудан бас тарту үшін негіз болады.',
        subtext: {
          type: null,
          content: [],
        },
      },
    ],
  },
  // 3
  {
    title: '3. Конкурсты өткізу тәртібі',
    list: [
      {
        id: 11,
        text: 'БИЛ-ге іріктеу жүргізу үшін конкурстық материалдарды Қордың оқу-әдістемелік кеңесі әзірлейді және бекітеді.',
        subtext: {
          type: null,
          content: [
            '11.1. Барлық қағаз және электрондық емтихан материалдары авторлық құқықпен қорғалып, тек конкурс кезіндегі емтиханда ғана пайдаланылады.',
            '11.2. Конкурсты өткізу үшін тест материалдарын Қор қызметкерлері БИЛ-ге конкурс басталғанға дейін қағаз түрінде (пломбаланған) жеткізеді.',
          ],
        },
      },
      {
        id: 12,
        text: 'Конкурс әрбір өңірде алдын ала айқындалған білім беру ұйымының базасында өтеді. Үміткерлер арасында конкурс және қорытынды шығару әрбір БИЛ бөлінісіне сәйкес жүргізіледі.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 13,
        text: 'Көкшетау, Атырау, Қызылорда қалаларында конкурстық іріктеу өткізу тәртібі:',
        subtext: {
          type: null,
          content: [
            '13.1. Ұлдар мен қыздар бірге білім алатын Ақмола облысы білім басқармасының «Білім-инновация» лицей-интернаты» КММ-де (бұдан әрі – «Көкшетау БИЛ») конкурстық іріктеу ұлдар мен қыздар бойынша жеке жүргізіледі.',
            '13.2. Атырау ерлер БИЛ-і мен Сарайшық ерлер БИЛ-іне конкурсқа тіркелу кезінде үміткер негізгі және екінші мектепті көрсетеді. Бұл ретте үміткер екі мектепте де конкурстық іріктеуге қатар қатысады.',
            '13.3. Қызылорда ерлер БИЛ, Қызылорда қыздар БИЛ және Қызылорда БИЛ физмат-қа конкурсқа тіркелу кезінде үміткер осы Ережелердің 8.6-тармағына сәйкес таңдаған негізгі және екінші мектепті де көрсетеді, екі мектепте бір уақытта конкурсқа қатысады.',
          ],
        },
      },
      {
        id: 14,
        text: 'Конкурс 2027 жылғы 2-мамырда өткізіледі.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 15,
        text: 'Конкурстық іріктеу бір турда өткізіледі. Конкурсқа қатысушылар саны екі лекке бөлінеді. Тест тапсыру уақыты, лек нөмірі рұқсат қағазында көрсетіледі.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 16,
        text: 'Конкурс офлайн форматта тестілеу түрінде өткізіледі. Тест тапсырмалары қағаз нұсқасында, яғни тест кітапшасы түрінде ұсынылады.',
        subtext: {
          type: null,
          content: [
            '16.1. Оқуға түсушілерге арналған тест 60 сұрақтан тұрады және мынадай пәндік бағыттарды қамтиды:',
            '• математика және логика – 50 сұрақ;',
            '• оқу сауаттылығы – 10 сұрақ.',
            '16.2. Тестілеуге берілетін уақыт - 110 минут;',
            '16.3. Тест материалдарын тарату, жауап парағының қызметтік секторларын толтыру, сондай-ақ, нұсқаулық беру уақыты көрсетілген тестілеу уақытына кірмейді;',
            '16.4. Үміткер тест кітапшасының бірінші бетіндегі нұсқаулықпен және ережелермен міндетті түрде танысуы тиіс.',
            '16.5. Үміткерлер жауап парағындағы қызметтік секторларды және тест кітапшасының мұқабасын толтырғаннан кейін, тестілеудің басталу және аяқталу уақыты тақтаға жазылады.',
            '16.6. Тестілеу уақытына тест сұрақтарына жауап беру, жауап парағындағы дөңгелекшелерді бояу кіреді.',
            '16.7. Әр үміткерге тест кітапшасы мен жауап парағы беріледі. Үміткер берілген тапсырмаларды тест кітапшасындағы бос орындарда орындайды, дұрыс жауаптарды жауап парағына белгілейді. Есептерді шығару үшін қосымша парақ берілмейді;',
            '16.8. Жауап парағы көк немесе қара түсті қаламмен толтырылады.',
          ],
        },
      },
      {
        id: 17,
        text: 'Тестілеудің қорытынды нәтижелерін есептеу кезінде дұрыс жауаптар саны «4» (төрт) коэффициентіне көбейтіледі, ал бір дұрыс емес жауап «-1» (минус бір) коэффициентіне көбейтіледі. Осылайша, жалпы қорытынды есептеледі. Төменде есептеу формула түрінде көрсетілген:\n(4 х дұрыс жауап + (-1) х дұрыс емес жауап = жалпы қорытынды ұпай).',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 18,
        text: 'Тестілеу аяқталғаннан кейін облыстардың және Астана, Алматы, Шымкент қалаларының қабылдау комиссиялары үміткерлердің жауап парақтарын жинап, нәтижелерін өңдеу және тексеру үшін Қордың конкурстық комиссиясына жібереді.',
        subtext: {
          type: null,
          content: [
            '18.1. Конкурс нәтижелерін өңдеуді конкурстық комиссия жауап парақтарын тексеру арқылы жүзеге асырады, тест кітапшасындағы белгіленген жауаптар жауап парағы ретінде қарастырылмайды.',
            '18.2. Конкурстық іріктеу нәтижелері тестілеу аяқталған соң 7 (жеті) күнтізбелік күннен кейін www.bilemtihan.kz сайтында жарияланады.',
            '18.3. Көкшетау БИЛ конкурстық іріктеу нәтижелері ұлдар мен қыздар бойынша жеке қарастырылады. Іріктеу нәтижелерінің негізінде ұлдар мен қыздарға арналған жеке сыныптар жасақталады.',
          ],
        },
      },
    ],
  },
  // 4
  {
    title: '4. Конкурс шарттары',
    list: [
      {
        id: 19,
        text: 'Тестілеу барысында үміткерлер мен қызметкерлердің өмірі мен денсаулығын қорғау, қауіпсіздігін қамтамасыз ету жауапкершілігі БИЛ директорына немесе директордың міндетін атқарушыға жүктеледі.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 20,
        text: 'Қабылдау емтиханын өткізу кезінде тестілеу аймағында бөгде адамдардың болуына жол берілмейді.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 21,
        text: 'Конкурс бір рет қана өткізіледі. Конкурсты қайта тапсыруға рұқсат берілмейді, қосымша конкурс өткізу күні белгіленбейді. Белгіленген күні және уақытта конкурсқа келмеген үміткер, келмеу себебіне қарамастан, конкурсқа қатыспаған болып есептеледі және ағымдағы оқу жылында БИЛ-ге қабылдау конкурсына қатысу құқығынан айырылады.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 22,
        text: 'Үміткер тестілеуге өзімен бірге көк немесе қара түсті қалам әкеледі.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 23,
        text: 'Үміткер тестілеу басталған уақыттан бастап 30 (отыз) минутқа кешіккен жағдайда емтиханға кіргізілмейді. Кешігіп келген үміткерге тестілеуге қосымша уақыт берілмейді.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 24,
        text: 'Тестілеу барысында үміткерге төмендегі әрекеттерге тыйым салынады:',
        subtext: {
          type: null,
          content: [
            '• аудиторияға шпаргалкаларды, жазбаларды, рефераттарды, конспектілерді және өзге де қосымша материалдарды алып кіруге және пайдалануға;',
            '• ұялы телефондарды, смарт-сағаттарды, планшеттерді және ақпаратты қабылдау, сақтау немесе тарату функциялары бар өзге де байланыс құралдарын пайдалануға;',
            '• тестілеу кезінде басқа үміткерлермен сөйлесуге;',
            '• әдепсіз сөздер айтуға, этикалық нормаларды бұзуға, басқа үміткерлерге немесе қызметкерлерге құрметсіздік танытуға;',
            '• тест материалдарымен алмасуға, басқа үміткерлердің жауаптарын көшіруге және алдау мақсатындағы өзге де әрекеттер жасауға;',
            '• аудитория бақылаушысының рұқсатынсыз орнынан тұруға немесе басқа орынға ауысуға;',
            '• аудитория бақылаушысының рұқсатынсыз аудиториядан шығуға;',
            '• тестілеу материалдарын (жауап парағы мен тест кітапшасын) бүлдіруге, беттерін жыртуға, оларды аудиториядан алып шығуға, сондай-ақ жауап парағында корректор сұйықтығын пайдалануға.',
            'Осы талаптарды бұзған үміткер тестілеуден шығарылады.',
          ],
        },
      },
    ],
  },
  // 5
  {
    title: '5. Конкурс нәтижелерін қайта қарау тәртібі',
    list: [
      {
        id: 25,
        text: 'Қабылдау емтиханы кезінде бірыңғай талаптардың сақталуын қамтамасыз ету және даулы мәселелерді шешу мақсатында мектепте төрағадан және кем дегенде екі мүшеден тұратын апелляциялық комиссия құрылады.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 26,
        text: 'Апелляциялық комиссия құрамы БИЛ директорының бұйрығымен бекітіледі.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 27,
        text: 'Апелляцияға өтінішті үміткердің ата-анасы немесе өзге де заңды өкілдері конкурстық іріктеудің қорытындылары жарияланған соң келесі күні сағат 10.00-ден 17.00–ге дейін онлайн түрде бере алады.',
        subtext: {
          type: null,
          content: [
            '27.1. Онлайн өтініш сілтемесі лицейдің қабылдау комиссиясының телефон нөміріне хабарласу арқылы алынады.',
            '27.2. Қабылданған өтініштер онлайн жүйеде автоматты түрде тіркеледі.',
          ],
        },
      },
      {
        id: 28,
        text: 'Апелляциялық комиссия өтінішті апелляцияға берген күннен кейін үш жұмыс күні ішінде қарастырып, шешімін шығарады.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 29,
        text: 'Апелляциялық комиссияға төмендегі сұрақтар бойынша өтініштер қабылданбайды:',
        subtext: {
          type: null,
          content: [
            '1) тест тапсырмаларының мазмұны мен құрылымы бойынша;',
            '2) тест тапсырмаларын орындау кезінде үміткерден талап етілген жалпыға бірдей міндетті тәртіп ережелерін бұзған жағдайда;',
            '3) үміткер жауап парағын дұрыс толтырмаған жағдайда;',
            '4) әрбір тапсырма бойынша дәлелді негіздеме көрсетілмеген барлық тест тапсырмаларын қайта қарау мақсатында.',
          ],
        },
      },
      {
        id: 30,
        text: 'Апелляциялық комиссия конкурс нәтижесін өзгеріссіз қалдыру немесе өзгерту туралы шешім қабылдай алады.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 31,
        text: 'Апелляциялық комиссия үміткерге не себепті ұпай қосылғандығы немесе қосылмағандығы туралы конкурстық комиссияға ақпарат береді.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 32,
        text: 'Апелляция қорытындысы туралы үміткердің ата-анасына немесе басқа да заңды өкіліне өтініште көрсетілген нөмір бойынша хабарланады.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 33,
        text: 'Емтиханды қайта тапсыруға рұқсат етілмейді.',
        subtext: {
          type: null,
          content: [],
        },
      },
    ],
  },
  // 6
  {
    title: '6. Оқушыны БИЛ-ге қабылдау тәртібі',
    list: [
      {
        id: 34,
        text: 'БИЛ-ге қабылдау үшін Қазақстан Республикасы Білім және ғылым министрінің 12.10.2018ж. № 564 бұйрығымен бекітілген «Білім беру ұйымдарына оқуға қабылдаудың үлгілік қағидаларының» 35 тармағына сәйкес төмендегі квоталар бекітіледі:',
        subtext: {
          type: null,
          content: [
            '1) «Мың бала» ауыл мектептерінің ұлттық зияткерлік олимпиада жеңімпаздары үшін 7-сыныпқа қабылданатын білім алушылардың жалпы санынан 10% мөлшерінде;',
            '2) халықтың әлеуметтік осал топтары үшін 7-сыныпқа қабылданатын білім алушылардың жалпы санының 15% мөлшерінде;',
            'Халықтың әлеуметтік осал топтарына, Қазақстан Республикасы Білім және ғылым министрінің 12.10.2018ж. № 564 бұйрығымен бекітілген «Білім беру ұйымдарына оқуға қабылдаудың үлгілік қағидаларының» 34 тармағына сәйкес:',
            '• жетім балалар, ата-анасының қамқорлығынсыз қалған балалар;',
            '• мүгедектігі бар балалар;',
            '• аналары «Алтын алқа», «Күміс алқа» алқаларымен наградталған немесе бұрын «Батыр ана» атағын алған, сондай-ақ, І және ІІ дәрежелі «Ана даңқы» ордендерімен марапатталған көп балалы отбасылардан шыққан балалар;',
            '• атаулы мемлекеттік әлеуметтік көмек алуға құқығы бар отбасылардан шыққан балалар, сондай-ақ атаулы әлеуметтік көмек алмайтын (жан басына шаққандағы табысы күнкөріс деңгейінен төмен) отбасылардан шыққан балалар;',
            '• бірінші топтағы мүгедектігі бар ата-аналардың балалары;',
            '• мүгедектігі бар баланы тәрбиелеп отырған немесе асырап отырған отбасылардың балалары;',
            '• отбасында тұратын жетім балалар және ата-анасының қамқорлығынсыз қалған балалар;',
            '• төтенше жағдайлар салдарынан шұғыл көмекке мұқтаж отбасылардан шыққан балалар;',
            '• мемлекеттік немесе қоғамдық міндеттерді, әскери қызметті атқару кезінде, ғарыш кеңістігіне ұшу немесе ұшу дайындығы барысында қаза тапқан (қайтыс болған) адамдардың отбасыларындағы балалар.',
            '3) Маңғыстау облысы, Жаңаөзен қаласындағы оқушылар үшін бесінші, алтыншы, жетінші, сегізінші және оныншы сыныптарға қабылданатын жалпы оқушылар санының 5% мөлшерінде, квоталарды бекітеді.',
          ],
        },
      },
      {
        id: 35,
        text: 'БИЛ-ге оқуға қабылдау конкурс нәтижесі бойынша жүзеге асырылады.',
        subtext: {
          type: null,
          content: [
            '35.1. Үміткерлерді, оның ішінде осы Ережелердің 34-тармағының 2) тармақшасында көрсетілгендерді оқуға қабылдау, әрбір лицейдің бөлінісінде бос орындарға сәйкес балдардың ең көп санына қарай жүзеге асырылады.',
            '35.2. Аралас (қазақ және орыс) тілде оқытатын БИЛ-ге үміткерлерді оқыту тілі бойынша оқуға қабылдау әрбір тілдік топ бөлінісінде жүзеге асырылады.',
            '35.2.1. Әр оқу жылында қазақ және орыс тілінде оқытылатын сыныптардың қатынасы тілдік топтар бойынша үміткерлер санына, сондай-ақ әрбір БИЛ-дің сыйымдылығы мен материалдық-техникалық мүмкіндіктеріне байланысты белгіленеді.',
            '35.3. Көкшетау БИЛ-іне оқуға үміткерлерді қабылдау ұлдар мен қыздар үшін бөлек жүргізіледі.',
            '35.3.1. Ұлдар мен қыздар сыныптарының қатынасы әр оқу жылында үміткер ұлдар мен қыздардың санының қатынасына және/немесе әрбір БИЛ-дің сыйымдылығы мен материалдық-техникалық мүмкіндіктеріне байланысты белгіленеді.',
            '35.3.2. Квоталар ұлдар мен қыздар сынып санына сәйкесінше бөлінеді.',
            '35.4. Атырау ерлер БИЛ және Сарайшық ерлер БИЛ-ге қабылдау келесі тәртіппен жүргізіледі:',
            '35.4.1. Үміткер алдымен өзі таңдаған негізгі мектептің конкурсына қатысады. Конкурс нәтижесі бойынша жинаған ұпайы жеткілікті болған жағдайда, үміткер негізгі мектепке қабылданады және екінші таңдаған мектебіне қабылдау үшін қарастырылмайды.',
            '35.4.2. Егер негізгі мектепке қабылдау үшін жинаған ұпайы жеткіліксіз, бірақ екінші мектепке жеткілікті болса, үміткерге екінші мектепке қабылдану мүмкіндігі ұсынылады. Бұл жағдайда үміткер негізгі мектептің резервтік тізімінде өз орнын сақтайды.',
            '35.5. Қызылорда ерлер БИЛ, Қызылорда қыздар БИЛ және Қызылорда БИЛ физмат-қа қабылдау келесі тәртіппен жүргізіледі:',
            '35.5.1. Үміткер алдымен өзі таңдаған негізгі мектептің конкурсына қатысады. Конкурс нәтижесі бойынша жинаған ұпайы жеткілікті болған жағдайда, үміткер негізгі мектепке қабылданады және екінші таңдаған мектебіне қабылдау үшін қарастырылмайды.',
            '35.5.2. Егер негізгі мектепке қабылдау үшін жинаған ұпайы жеткіліксіз, бірақ екінші мектепке жеткілікті болса, үміткерге екінші мектепке қабылдану мүмкіндігі ұсынылады. Бұл жағдайда үміткер негізгі мектептің резервтік тізімінде өз орнын сақтайды.',
          ],
        },
      },
      {
        id: 36,
        text: 'Алынған ұпай сандары бірдей болған жағдайда, басымдық деңгейі бойынша мынадай көрсеткіштер бағаланатын болады:',
        subtext: {
          type: null,
          content: [
            '1) математика және логика бойынша ең көп ұпай жинағандар;',
            '2) тестілеу кезінде ең аз қате жібергендер;',
            '3) ауыл мектептерінің білім алушылары.',
            'БИЛ-дің жобалық қуаты мен сыныптардың толымдылығына сүйене отырып, бір сыныптағы білім алушылардың ең көп саны 25 (жиырма бес) білім алушыны құрайды.',
          ],
        },
      },
      {
        id: 37,
        text: 'Үміткерлерді конкурстық іріктеу қорытындылары конкурстық комиссиясының хаттамасымен рәсімделеді және www.bilemtihan.kz сайтында орналастырылады.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 38,
        text: 'Конкурстық іріктеу қорытындылары www.bilemtihan.kz сайтында үміткердің дербес деректерін, олардың таралуын болдырмау мақсатында, шифрлау арқылы орналастырылады.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 39,
        text: 'www.bilemtihan.kz сайтында орналасқан конкурстық іріктеу қорытындыларын тек конкурстық іріктеуге тіркелген үміткерлер үшін жеке кабинетте көруге болады.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 40,
        text: 'Конкурс қорытындылары бойынша БИЛ-ге оқуға қабылданған үміткерлер ағымдағы жылдың 20 маусымына дейін облыстардың және Астана, Алматы, Шымкент қалаларының қабылдау комиссиясына оқуға құжаттарды белгіленген тізбеге сәйкес тапсырады.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 41,
        text: 'Резервтік тізімге конкурс іріктеуінің нәтижесі бойынша негізгі бос орындарға кірмеген үміткерлер арасынан жинаған ұпайларының қосындысы бойынша кему тәртібінде www.bilemtihan.kz сайтында орналастырылған барлық оқушылар кіреді.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 42,
        text: 'Егер БИЛ-ге оқуға қабылданған үміткер осы Ережелердің 40-тармағында көрсетілген мерзімде құжаттарын тапсырмаса, оның орнына резервтік тізімнен келесі үміткер шақырылады.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 43,
        text: 'БИЛ-ге қабылданған үміткер оқудан бас тартқан жағдайда, оның орнына резервтік тізімнен келесі үміткер шақырылады.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 44,
        text: 'Резервтік тізімге енгізілген үміткерлер бос орын болған жағдайда, сол оқу жылының ішінде резервтік тізімдегі кезектілік тәртібіне сәйкес оқуға қабылдануы мүмкін.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 45,
        text: 'Лицейлер арасында 7-сынып оқушыларын ауыстыру қарастырылмайды.',
        subtext: {
          type: null,
          content: [],
        },
      },
    ],
  },
  // 7
  {
    title: '7. Қорытынды ереже',
    list: [
      {
        id: 46,
        text: 'Осы Ережелермен реттелмеген мәселелер Қазақстан Республикасының қолданыстағы заңнамасына, ішкі құқықтық актілеріне және БИЛ Жарғысына сәйкес шешіледі.',
        subtext: {
          type: null,
          content: [],
        },
      },
    ],
  },
];

export const RUS_RULES = [
  // 1
  {
    title: '1. Общие положения',
    list: [
      {
        id: 1,
        text: 'Настоящие Правила приема на обучение в лицеи «Білім-инновация» (далее – Правила) разработаны в соответствии с Законом Республики Казахстан «Об образовании» от 27 июля 2007 года, Типовыми правилами деятельности организаций образования соответствующих типов и видов, за исключением организаций высшего и послевузовского образования, утвержденными приказом Министра просвещения Республики Казахстан от 31 августа 2022 года № 385, Типовыми правилами приема на обучение в организации образования, реализующие общеобразовательные учебные программы начального, основного среднего и общего среднего образования, за исключением республиканских, областных, городов республиканского значения и столицы специализированных школ-интернатов-колледжей олимпийского резерва и областных, городов республиканского значения и столицы школ-интернатов для одаренных в спорте детей, утвержденными приказом Министра образования и науки Республики Казахстан от 12 октября 2018 года № 564.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 2,
        text: 'Прием на обучение в лицеи «Білім-инновация» (далее – БИЛ) осуществляется на конкурсной основе (далее – конкурс).',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 3,
        text: 'В конкурсе могут принимать участие обучающиеся 6 классов общеобразовательных школ Республики Казахстан (далее – претенденты).',
        subtext: {
          type: null,
          content: [],
        },
      },
    ],
  },
  // 2
  {
    title: '2. Порядок приема документов',
    list: [
      {
        id: 4,
        text: 'Для организации и проведения конкурса приказом президента Международного общественного фонда «БІЛІМ-ИННОВАЦИЯ» (далее – Фонд) создается конкурсная комиссия в составе 5 (пяти) человек из числа руководства, методистов и специалистов Фонда.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 5,
        text: 'Для приема документов на участие в конкурсе и проведения тестирования в областях и городах Астана, Алматы, Шымкент приказом директора БИЛ/исполняющего обязанности директора создается приемная комиссия в составе 5 (пяти) человек из числа педагогов и сотрудников БИЛ.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 6,
        text: 'Приказом директора БИЛ/исполняющего обязанности директора назначается лицо, ответственное за прием документов.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 7,
        text: 'Прием документов для участия в конкурсе от родителей или иных законных представителей претендента на поступление в БИЛ осуществляется с 2 ноября 2026 года по 2 апреля 2027 года.',
        subtext: {
          type: null,
          content: [
            '7.1. Для участия в конкурсе родитель или иной законный представитель претендента в установленные сроки проходит регистрацию по ссылке www.bilemtihan.kz.',
          ],
        },
      },
      {
        id: 8,
        text: 'Для участия в конкурсе необходимы электронные версии следующих документов (формат файлов для загрузки: .jpg, .jpeg, .pdf):',
        subtext: {
          type: null,
          content: [
            '1) копия свидетельства о рождении претендента с указанием ИИН;',
            '2) фотография претендента на светлом фоне;',
            '3) документы, подтверждающие принадлежность к социально уязвимым категориям населения (при наличии).',
            '8.1. Представление оригиналов документов не требуется (за исключением документа, указанного в подпункте 3) пункта 8, оригинал которого представляется в приемную комиссию БИЛ в течение 5 рабочих дней после регистрации на сайте www.bilemtihan.kz).',
            '8.2. После завершения приема документов приемная комиссия проверяет представленные документы на соответствие критериям отбора и при необходимости дополнительно запрашивает оригиналы подтверждающих документов.',
            '8.3. По завершении проверки документов на номер телефона или адрес электронной почты родителей или иных законных представителей претендента, указанные при регистрации, направляется пропуск.',
            '8.4. При явке на тестирование претендент для идентификации личности предъявляет свидетельство о рождении (оригинал) и пропуск в бумажном виде.',
            '8.5. При приеме документов в БИЛ для мальчиков в городе Атырау – КГУ «№1 Лицей-интернат «Білім-инновация» Управления образования Атырауской области» (далее – «Атырау ерлер БИЛ») и КГУ «№2 Лицей-интернат «Білім-инновация» Управления образования Атырауской области» (далее – «Сарайшық ерлер БИЛ») претендент должен указать приоритетность школ путем выбора основной и второй школы.',
            '8.6. При приеме документов в БИЛ города Кызылорда – КГУ «Областной лицей-интернат «Білім-инновация» для одаренных детей №9 имени Сейілбека Шаухаманова» управления образования Кызылординской области (далее – «Қызылорда ерлер БИЛ»), КГУ «Областной лицей-интернат «Білім-инновация» для одаренных детей №10» управления образования Кызылординской области (далее – «Қызылорда қыздар БИЛ») и лицей-интернат «Білім-инновация» физико-математического направления управления образования Кызылординской области (далее – «Қызылорда БИЛ физмат») претендент в зависимости от пола является претендентом в две соответствующие школы:',
            '• мальчики – в «Қызылорда ерлер БИЛ» и «Қызылорда БИЛ физмат»;',
            '• девочки – в «Қызылорда қыздар БИЛ» и «Қызылорда БИЛ физмат», и должен указать приоритетность школ путем выбора основной и второй школы.',
          ],
        },
      },
      {
        id: 9,
        text: 'Для регистрации на участие в конкурсе по месту жительства, при наличии в области нескольких центров тестирования, претендент выбирает наиболее удобное для него место сдачи экзамена; при выдаче пропуска указывается адрес выбранного центра тестирования.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 10,
        text: 'Основаниями для отказа в приеме документов являются подача заявления об участии в конкурсе позже установленного срока, повторная регистрация претендента, уже прошедшего регистрацию в любом из БИЛ, либо представление неполного пакета документов.',
        subtext: {
          type: null,
          content: [],
        },
      },
    ],
  },
  // 3
  {
    title: '3. Порядок проведения конкурса',
    list: [
      {
        id: 11,
        text: 'Конкурсные материалы для проведения отбора в БИЛ разрабатываются и утверждаются учебно-методическим советом Фонда.',
        subtext: {
          type: null,
          content: [
            '11.1. Все бумажные и электронные экзаменационные материалы защищены авторским правом и используются только на экзамене в ходе конкурса.',
            '11.2. Тестовые материалы для проведения конкурса доставляются в БИЛ сотрудниками Фонда в бумажном виде (опломбированными) до начала конкурса.',
          ],
        },
      },
      {
        id: 12,
        text: 'Конкурс проводится в каждом регионе на базе заранее определенной организации образования. Конкурс и подведение итогов среди претендентов проводятся в разрезе каждого БИЛ.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 13,
        text: 'Порядок проведения конкурсного отбора в городах Кокшетау, Атырау, Кызылорда:',
        subtext: {
          type: null,
          content: [
            '13.1. Конкурсный отбор в КГУ «Лицей-интернат «Білім-инновация» управления образования Акмолинской области» (далее – «Кокшетау БИЛ»), в котором мальчики и девочки обучаются совместно, проводится раздельно для мальчиков и для девочек.',
            '13.2. При регистрации на конкурс в Атырау ерлер БИЛ и Сарайшық ерлер БИЛ претендент указывает основную и вторую школы. При этом претендент одновременно участвует в конкурсном отборе в обе школы.',
            '13.3. При регистрации на конкурс в Қызылорда ерлер БИЛ, Қызылорда қыздар БИЛ и Қызылорда БИЛ физмат претендент указывает основную и вторую школы, выбранные в соответствии с пунктом 8.6 настоящих Правил, и одновременно участвует в конкурсе в обе школы.',
          ],
        },
      },
      {
        id: 14,
        text: 'Конкурс проводится 2 мая 2027 года.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 15,
        text: 'Конкурсный отбор проводится в один тур. Участники конкурса распределяются на два потока. Время сдачи теста и номер потока указываются в пропуске.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 16,
        text: 'Конкурс проводится в офлайн-формате в форме тестирования. Тестовые задания предоставляются в бумажном варианте, то есть в виде тестовой книжки.',
        subtext: {
          type: null,
          content: [
            '16.1. Тест для поступающих состоит из 60 вопросов и включает следующие предметные направления:',
            '• математика и логика – 50 вопросов;',
            '• грамотность чтения – 10 вопросов.',
            '16.2. Время, отведенное на тестирование, – 110 минут;',
            '16.3. Время на раздачу тестовых материалов, заполнение служебных секторов листа ответов, а также проведение инструктажа в указанное время тестирования не включается;',
            '16.4. Претендент обязан ознакомиться с инструкцией и правилами, размещенными на первой странице тестовой книжки.',
            '16.5. После заполнения претендентами служебных секторов листа ответов и обложки тестовой книжки на доске записывается время начала и окончания тестирования.',
            '16.6. Время тестирования включает ответы на тестовые вопросы и закрашивание кружков в листе ответов.',
            '16.7. Каждому претенденту выдаются тестовая книжка и лист ответов. Претендент выполняет задания на свободных местах тестовой книжки, правильные ответы отмечает в листе ответов. Дополнительные листы для решения задач не выдаются;',
            '16.8. Лист ответов заполняется ручкой с синей или черной пастой.',
          ],
        },
      },
      {
        id: 17,
        text: 'При подсчете итоговых результатов тестирования количество правильных ответов умножается на коэффициент «4» (четыре), а каждый неправильный ответ – на коэффициент «-1» (минус один). Таким образом рассчитывается общий итог. Формула расчета:\n(4 х правильные ответы + (-1) х неправильные ответы = общий итоговый балл).',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 18,
        text: 'По окончании тестирования приемные комиссии областей и городов Астана, Алматы, Шымкент собирают листы ответов претендентов и направляют их в конкурсную комиссию Фонда для обработки и проверки результатов.',
        subtext: {
          type: null,
          content: [
            '18.1. Обработка результатов конкурса осуществляется конкурсной комиссией путем проверки листов ответов; ответы, отмеченные в тестовой книжке, в качестве листа ответов не рассматриваются.',
            '18.2. Результаты конкурсного отбора публикуются на сайте www.bilemtihan.kz по истечении 7 (семи) календарных дней после окончания тестирования.',
            '18.3. Результаты конкурсного отбора в Кокшетау БИЛ рассматриваются раздельно для мальчиков и для девочек. На основании результатов отбора комплектуются отдельные классы для мальчиков и для девочек.',
          ],
        },
      },
    ],
  },
  // 4
  {
    title: '4. Условия конкурса',
    list: [
      {
        id: 19,
        text: 'Ответственность за охрану жизни и здоровья, обеспечение безопасности претендентов и сотрудников во время тестирования возлагается на директора БИЛ или лицо, исполняющее обязанности директора.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 20,
        text: 'Во время проведения вступительного экзамена нахождение посторонних лиц в зоне тестирования не допускается.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 21,
        text: 'Конкурс проводится только один раз. Повторная сдача конкурса не допускается, дополнительная дата проведения конкурса не назначается. Претендент, не явившийся на конкурс в установленные день и время, независимо от причины неявки считается не участвовавшим в конкурсе и лишается права на участие в конкурсе по приему в БИЛ в текущем учебном году.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 22,
        text: 'Претендент приносит с собой на тестирование ручку с синей или черной пастой.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 23,
        text: 'При опоздании на 30 (тридцать) минут с момента начала тестирования претендент к экзамену не допускается. Опоздавшему претенденту дополнительное время на тестирование не предоставляется.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 24,
        text: 'Во время тестирования претенденту запрещается:',
        subtext: {
          type: null,
          content: [
            '• вносить в аудиторию и использовать шпаргалки, записи, рефераты, конспекты и иные вспомогательные материалы;',
            '• пользоваться мобильными телефонами, смарт-часами, планшетами и иными средствами связи, имеющими функции приема, хранения или передачи информации;',
            '• переговариваться с другими претендентами во время тестирования;',
            '• использовать нецензурные выражения, нарушать этические нормы, проявлять неуважение к другим претендентам или сотрудникам;',
            '• обмениваться тестовыми материалами, списывать ответы у других претендентов и совершать иные действия, направленные на обман;',
            '• вставать с места или пересаживаться на другое место без разрешения дежурного по аудитории;',
            '• выходить из аудитории без разрешения дежурного по аудитории;',
            '• портить тестовые материалы (лист ответов и тестовую книжку), вырывать из них страницы, выносить их из аудитории, а также пользоваться корректирующей жидкостью в листе ответов.',
            'Претендент, нарушивший указанные требования, удаляется с тестирования.',
          ],
        },
      },
    ],
  },
  // 5
  {
    title: '5. Порядок обжалования результатов конкурса',
    list: [
      {
        id: 25,
        text: 'Для обеспечения соблюдения единых требований и разрешения спорных вопросов во время вступительного экзамена при школе создается апелляционная комиссия, состоящая из председателя и не менее двух членов.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 26,
        text: 'Состав апелляционной комиссии утверждается приказом директора БИЛ.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 27,
        text: 'Заявление на апелляцию подается родителями или иными законными представителями претендента онлайн на следующий день после опубликования итогов конкурсного отбора с 10.00 до 17.00 часов.',
        subtext: {
          type: null,
          content: [
            '27.1. Ссылка на онлайн-заявление предоставляется при обращении по номеру телефона приемной комиссии лицея.',
            '27.2. Принятые заявления автоматически регистрируются в онлайн-системе.',
          ],
        },
      },
      {
        id: 28,
        text: 'Апелляционная комиссия рассматривает заявление и выносит решение в течение трех рабочих дней со дня подачи заявления на апелляцию.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 29,
        text: 'Апелляционной комиссией не принимаются заявления по вопросам:',
        subtext: {
          type: null,
          content: [
            '1) содержания и структуры тестовых заданий;',
            '2) связанным с нарушением претендентом установленных правил поведения во время выполнения тестовых заданий;',
            '3) неправильного заполнения претендентом листа ответов;',
            '4) пересмотра всех тестовых заданий без указания мотивированного обоснования по каждому заданию.',
          ],
        },
      },
      {
        id: 30,
        text: 'Апелляционная комиссия может принять решение об оставлении результата конкурса без изменения либо о его изменении.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 31,
        text: 'Апелляционная комиссия информирует конкурсную комиссию о причинах начисления либо неначисления баллов претенденту.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 32,
        text: 'Об итогах апелляции сообщается родителям или иным законным представителям претендента по номеру телефона, указанному в заявлении.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 33,
        text: 'Пересдача экзамена не допускается.',
        subtext: {
          type: null,
          content: [],
        },
      },
    ],
  },
  // 6
  {
    title: '6. Порядок зачисления обучающихся в БИЛ',
    list: [
      {
        id: 34,
        text: 'Для зачисления в БИЛ в соответствии с пунктом 35 Типовых правил приема на обучение в организации образования, утвержденных приказом Министра образования и науки Республики Казахстан от 12 октября 2018 года № 564, устанавливаются следующие квоты:',
        subtext: {
          type: null,
          content: [
            '1) в размере 10% от общего количества обучающихся, принимаемых в 7 классы, для победителей национальной интеллектуальной олимпиады сельских школ «Мың бала»;',
            '2) в размере 15% от общего количества обучающихся, принимаемых в 7 классы, для социально уязвимых категорий населения;',
            'К социально уязвимым категориям населения в соответствии с пунктом 34 Типовых правил приема на обучение в организации образования, утвержденных приказом Министра образования и науки Республики Казахстан от 12 октября 2018 года № 564, относятся:',
            '• дети-сироты, дети, оставшиеся без попечения родителей;',
            '• дети с инвалидностью;',
            '• дети, матери которых награждены подвесками «Алтын алқа» или «Күміс алқа», орденами «Материнская слава» I или II степени либо ранее получили звание «Мать-героиня», при условии что семьи являются многодетными;',
            '• дети из семей, имеющих право на получение государственной адресной социальной помощи, а также из семей, не получающих государственную адресную социальную помощь, в которых среднедушевой доход ниже величины прожиточного минимума;',
            '• дети родителей с инвалидностью первой группы;',
            '• дети из семей, имеющих или воспитывающих ребенка с инвалидностью;',
            '• дети-сироты и дети, оставшиеся без попечения родителей, проживающие в семьях;',
            '• дети из семей, требующих экстренной помощи в результате чрезвычайных ситуаций;',
            '• дети из семей лиц, погибших (умерших) при исполнении государственных или общественных обязанностей, воинской службы, при подготовке или осуществлении полета в космическое пространство.',
            '3) в размере 5% от общего количества обучающихся, принимаемых в пятые, шестые, седьмые, восьмые и десятые классы, – для обучающихся города Жанаозен Мангистауской области.',
          ],
        },
      },
      {
        id: 35,
        text: 'Зачисление на обучение в БИЛ осуществляется по результатам конкурса.',
        subtext: {
          type: null,
          content: [
            '35.1. Зачисление претендентов, в том числе указанных в подпункте 2) пункта 34 настоящих Правил, осуществляется в соответствии с количеством вакантных мест в разрезе каждого лицея по наибольшему количеству набранных баллов.',
            '35.2. Зачисление претендентов на обучение в БИЛ со смешанным (казахским и русским) языком обучения осуществляется в разрезе каждой языковой группы.',
            '35.2.1. Соотношение классов с казахским и русским языками обучения в каждом учебном году определяется в зависимости от количества претендентов по языковым группам, а также вместимости и материально-технических возможностей каждого БИЛ.',
            '35.3. Зачисление претендентов на обучение в Кокшетау БИЛ проводится раздельно для мальчиков и для девочек.',
            '35.3.1. Соотношение классов для мальчиков и для девочек в каждом учебном году определяется в зависимости от соотношения количества претендентов-мальчиков и претендентов-девочек и/или вместимости и материально-технических возможностей каждого БИЛ.',
            '35.3.2. Квоты распределяются в соответствии с количеством классов для мальчиков и для девочек.',
            '35.4. Зачисление в Атырау ерлер БИЛ и Сарайшық ерлер БИЛ проводится в следующем порядке:',
            '35.4.1. Претендент сначала участвует в конкурсе в выбранную им основную школу. Если по результатам конкурса набранных баллов достаточно, претендент зачисляется в основную школу и для зачисления во вторую выбранную школу не рассматривается.',
            '35.4.2. Если набранных баллов недостаточно для зачисления в основную школу, но достаточно для второй школы, претенденту предлагается возможность зачисления во вторую школу. В этом случае претендент сохраняет свое место в резервном списке основной школы.',
            '35.5. Зачисление в Қызылорда ерлер БИЛ, Қызылорда қыздар БИЛ и Қызылорда БИЛ физмат проводится в следующем порядке:',
            '35.5.1. Претендент сначала участвует в конкурсе в выбранную им основную школу. Если по результатам конкурса набранных баллов достаточно, претендент зачисляется в основную школу и для зачисления во вторую выбранную школу не рассматривается.',
            '35.5.2. Если набранных баллов недостаточно для зачисления в основную школу, но достаточно для второй школы, претенденту предлагается возможность зачисления во вторую школу. В этом случае претендент сохраняет свое место в резервном списке основной школы.',
          ],
        },
      },
      {
        id: 36,
        text: 'При равном количестве набранных баллов оцениваются следующие показатели по уровню приоритетности:',
        subtext: {
          type: null,
          content: [
            '1) набравшие наибольшее количество баллов по математике и логике;',
            '2) допустившие наименьшее количество ошибок при тестировании;',
            '3) обучающиеся сельских школ.',
            'Исходя из проектной мощности БИЛ и наполняемости классов, максимальное количество обучающихся в одном классе составляет 25 (двадцать пять) обучающихся.',
          ],
        },
      },
      {
        id: 37,
        text: 'Итоги конкурсного отбора претендентов оформляются протоколом конкурсной комиссии и размещаются на сайте www.bilemtihan.kz.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 38,
        text: 'Итоги конкурсного отбора размещаются на сайте www.bilemtihan.kz с шифрованием персональных данных претендентов в целях предотвращения их распространения.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 39,
        text: 'Итоги конкурсного отбора, размещенные на сайте www.bilemtihan.kz, доступны для просмотра в личном кабинете только претендентам, прошедшим регистрацию на конкурсный отбор.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 40,
        text: 'Претенденты, зачисленные на обучение в БИЛ по итогам конкурса, до 20 июня текущего года представляют в приемные комиссии областей и городов Астана, Алматы, Шымкент документы для обучения в соответствии с установленным перечнем.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 41,
        text: 'В резервный список включаются все претенденты, не вошедшие в основные вакантные места по результатам конкурсного отбора, в порядке убывания суммы набранных баллов, размещенные на сайте www.bilemtihan.kz.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 42,
        text: 'В случае, если претендент, зачисленный на обучение в БИЛ, не представил документы в срок, установленный пунктом 40 настоящих Правил, на его место приглашается следующий претендент из резервного списка.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 43,
        text: 'Если претендент, зачисленный в БИЛ, отказывается от обучения, на его место приглашается следующий претендент из резервного списка.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 44,
        text: 'Претенденты, включенные в резервный список, при наличии вакантных мест могут быть зачислены на обучение в течение того же учебного года в порядке очередности резервного списка.',
        subtext: {
          type: null,
          content: [],
        },
      },
      {
        id: 45,
        text: 'Перевод обучающихся 7 классов между лицеями не предусмотрен.',
        subtext: {
          type: null,
          content: [],
        },
      },
    ],
  },
  // 7
  {
    title: '7. Заключительные положения',
    list: [
      {
        id: 46,
        text: 'Вопросы, не урегулированные настоящими Правилами, решаются в соответствии с действующим законодательством Республики Казахстан, внутренними правовыми актами и Уставом БИЛ.',
        subtext: {
          type: null,
          content: [],
        },
      },
    ],
  },
];

export function PassRules() {
  return (
    <div className='flex flex-row justify-evenly px-4 pb-4'>
      <div>
        <ol className='pr-4'>
          <li>
            <span className=' font-semibold'>
              1. Өзіңізбен бірге болуы қажет:
            </span>
            <ul className='list-inside indent-4'>
              <li>&bull; Туу туралы куәлік</li>
              <li>&bull; Рұқсатнама (қағаз түрінде)</li>
              <li>&bull; Қара/көк сиялы қалам</li>
            </ul>
          </li>
          <li>
            <span className=' font-semibold'>
              2. Емтиханға уақытында келуіңіз керек.
            </span>
            <ul className='list-inside pl-4'>
            <li>&bull; Емтиханға 30 минут және одан көп уақытқа кешіккен жағдайда, үміткер емтиханға жіберілмейді.</li>
            </ul>
          </li>
          <li>
            <span className=' font-semibold'>
              3. Тыйым салынады:
            </span>

            <ul className='list-inside indent-4'>
            <li>&bull; Смартфон</li>
            <li>&bull; Кез келген гаджет</li>
            <li>
                &bull; Кеңсе құралдар (калькулятор, кітап, қағаз…)
              </li>
              <li>
                &bull; Көшіруге немесе өзгелерге көмектесуге
              </li>
            </ul>
          </li>
        </ol>
      </div>
      <div className='border-l-2 pl-4'>
        <ol className=''>
          <li>
            <span className=' font-semibold'>
              1. При себе необходимо иметь:
            </span>
            <ul className='list-inside indent-4'>
              <li>&bull; Свидетельство о рождении</li>
              <li>&bull; Пропуск (в бумажном виде)</li>
              <li>&bull; Ручка с черной/синей пастой</li>
            </ul>
          </li>
          <li>
            <span className=' font-semibold'>
              2. Необходимо прибыть на экзамен вовремя.
            </span>
            <ul className='list-inside pl-4'>
            <li>&bull; В случае опоздания на 30 минут и более кандидат к экзамену не допускается.</li>
            </ul>
          </li>
          <li>
            <span className=' font-semibold'>3. Запрещается:</span>

            <ul className='list-inside indent-4'>
              <li>&bull; Смартфон</li>
              <li>
                &bull; Любые гаджеты
              </li>
              <li>
                &bull; Канцелярские товары (калькулятор, книга, бумага …)
              </li>
              <li>
                &bull; Списывать или оказывать помощь другим участникам.
              </li>
            </ul>
          </li>
        </ol>
      </div>
    </div>
  );
}
